import { render, staticRenderFns } from "./history-record-board-final.vue?vue&type=template&id=51fc7332"
import script from "./history-record-board-final.vue?vue&type=script&lang=js"
export * from "./history-record-board-final.vue?vue&type=script&lang=js"
import style0 from "./history-record-board-final.vue?vue&type=style&index=0&id=51fc7332&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports